import api from ".";
import generateHeaders from "../utils/generateHeaders.js";

export const getContractProductsService = async (
  { token, contractNumber, systemUserId }
) => {
  const headers = generateHeaders(token);

  return await api.get(
    `/ecommerce/products?contractNumber=${contractNumber}&userId=${systemUserId}`,
    headers
  );
};

export const getAvaliableProductsService = async ({
  token,
  eventId,
  contractNumber,
}) => {
  const headers = generateHeaders(token);

  return await api.get(
    `/admin/ecommerce/get-products-to-cart?eventId=${eventId}&contractNumber=${contractNumber}`,
    headers
  );
};

export const getContractInfoService = async ({
  token,
  serviceOpportunityNumber,
  userId,
}) => {
  const headers = generateHeaders(token);

  const userIdParam = userId ? `?userId=${userId}` : "";

  return await api.get(
    `/admin/opportunity/${serviceOpportunityNumber}${userIdParam}`,
    headers
  );
};

export const getEventService = async ({ token }) => {
  const headers = generateHeaders(token);

  return await api.get(`/admin/events`, headers);
};

export const getStaffAttendenceTableService = async ({
  token,
  eventId,
  roleType,
  year,
  page,
  size,
  sortBy,
  sortDirection,
}) => {
  const headers = generateHeaders(token);

  const options = {
    ...headers,
    params: {
      roleType,
      ...(year && { year }),
      page,
      size,
      sortBy,
      sortDirection,
    },
  };

  return await api.get(`/staff/attendance/event/${eventId}/filter`, options);
};

export const getStaffAttendenceInfoService = async ({
  token,
  eventId,
  roleType,
  year,
}) => {
  const headers = generateHeaders(token);

  const options = {
    ...headers,
    params: {
      roleType,
      ...(year && { year }),
    },
  };

  return await api.get(`/staff/attendance/event/${eventId}/metrics`, options);
};
